export default {
	comeon: {
		en_XX: {
			department: 'ComeOn! EN',
			tag: 'comeonen'
		},
		es_CL: {
			department: 'ComeOn! EN',
			tag: 'comeonen'
		},
		no_NO: {
			department: 'ComeOn! NOR',
			tag: 'comeonnor'
		},
		en_CA: {
			department: 'ComeOn! CA',
			tag: 'comeonca'
		},
		en_IN: {
			department: 'ComeOn! IN',
			tag: 'comeonin'
		},
		da_DK: {
			department: 'ComeOn! DK',
			tag: 'comeondk'
		},
		de_DE: {
			department: 'ComeOn! DE',
			tag: 'comeonde'
		},
		fi_FI: {
			department: 'ComeOn! FI',
			tag: 'comeonfi'
		},
		sv_SE: {
			department: 'ComeOn! SE',
			tag: 'comeonse'
		},
		en_ON: {
			department: 'ComeOn! ON',
			tag: 'comeonon'
		}
	},
	mobilebet: {
		no_NO: {
			department: 'Mobilebet NOR',
			tag: 'mobilebetnor'
		},
		en_XX: {
			department: 'Mobilebet EN',
			tag: 'mobilebeten'
		},
		en_NZ: {
			department: 'Mobilebet NZ',
			tag: 'mobilebetnz'
		},
		de_DE: {
			department: 'Mobilebet DE',
			tag: 'mobilebetde'
		},
		fi_FI: {
			department: 'Mobilebet FI',
			tag: 'mobilebetfi'
		}
	},
	suomikasino: {
		fi_FI: {
			department: 'Suomikasino FI',
			tag: 'suomikasinofi'
		}
	},
	nopeampi: {
		fi_FI: {
			department: 'Nopeampi FI',
			tag: 'nopeampifi'
		}
	},
	galaksino: {
		fi_FI: {
			department: 'Galaksino FI',
			tag: 'galaksino'
		}
	},
	getlucky: {
		en_XX: {
			department: 'Getlucky EN',
			tag: 'getluckyen'
		},
		no_NO: {
			department: 'Getlucky NOR',
			tag: 'getluckynor'
		}
	},
	mobilautomaten: {
		sv_SE: {
			department: 'Mobilautomaten SE',
			tag: 'mobilautomatense'
		},
		no_NO: {
			department: 'Mobilautomaten NOR',
			tag: 'mobilautomatennor'
		},
		de_DE: {
			department: 'Mobilautomaten DE',
			tag: 'mobilautomatende'
		}
	},
	folkeautomaten: {
		no_NO: {
			department: 'Folkeautomaten NOR',
			tag: 'folkeautomatennor'
		}
	},
	casinostugan: {
		sv_SE: {
			department: 'Casinostugan SE',
			tag: 'casinostuganse'
		}
	},
	snabbare: {
		sv_SE: {
			department: 'Snabbare SE',
			tag: 'snabbarese'
		}
	},
	hajper: {
		sv_SE: {
			department: 'Hajper SE',
			tag: 'hajperse'
		}
	},
	pzbuk: {
		pl_PL: {
			department: 'PZBuk',
			tag: 'pzbuk'
		}
	},
	folkeriket: {
		no_NO: {
			department: 'Folkeriket NOR',
			tag: 'folkeriketnor'
		}
	},
	lyllo: {
		sv_SE: {
			department: 'Lyllo SE',
			tag: 'lyllose'
		}
	},
	norgesspill: {
		no_NO: {
			department: 'Norgesspill NOR',
			tag: 'norgesspillnor'
		},
		en_XX: {
			department: 'Norgesspill NOR',
			tag: 'norgesspillnor'
		}
	},
	cherrycasino: {
		en_XX: {
			department: 'Cherry Casino EN',
			tag: 'cherrycasinoen'
		},
		ja_JP: {
			department: 'Cherry Casino JP',
			tag: 'cherrycasinojp'
		}
	},
	sunmaker: {
		de_DE: {
			department: 'Sunmaker DE',
			tag: 'sunmakerde'
		}
	}
};
